__turbopack_context__.v({
  "active": "status-badge-module-scss-module__xql65q__active",
  "canceled": "status-badge-module-scss-module__xql65q__canceled",
  "closed": "status-badge-module-scss-module__xql65q__closed",
  "component": "status-badge-module-scss-module__xql65q__component",
  "expired": "status-badge-module-scss-module__xql65q__expired",
  "inactive": "status-badge-module-scss-module__xql65q__inactive",
  "other": "status-badge-module-scss-module__xql65q__other",
});
